"use strict";
import React from "react";
import { List, ListItemButton, ListItemText } from "@mui/material";
import { NavLink } from "react-router-dom";

const navItems = [
    { text: "Voice Catalogue", to: "voice-catalogue" },
    { text: "Voice Sandbox", to: "voice-sandbox" },
    { text: "Voice Benchmarks", to: "voice-benchmarks" },
    { text: "API Sandbox", to: "api-sandbox" },
    { text: "API Documentation", to: "api-documentation" },
];

// Sidebar with navigation for API sections
const ApiSidebar = () => {
    return (
        <List sx={{ width: 240, bgcolor: "var(--color-section-bg)" }}>
            {navItems.map((item) => (
                <ListItemButton
                    key={item.to}
                    component={NavLink}
                    to={item.to}
                    sx={{ "&.active": { backgroundColor: "var(--color-dropdown-hover-bg)" } }}
                >
                    <ListItemText primary={item.text} />
                </ListItemButton>
            ))}
        </List>
    );
};

export default ApiSidebar;
